import React, { useRef, useEffect, useState } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import styles from "./Invoice.module.scss";
import qrcode from "../../../images/qr.png";
import { useDispatch, useSelector } from "react-redux";
import { getMyCollection } from "../../../store/slices/sales";
import { useNavigate } from "react-router-dom";

const MyCollection = () => {
  const cardRef = useRef(null);
  const navigate = useNavigate();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { myCollection } = useSelector((state) => state.sales);
  const { token } = useSelector((state) => state.auth);
  const currentDate = new Date().toISOString().split("T")[0];
  const clinicId = clinicInfo?.[0]?.clinicId || null;
  const totalAmount = myCollection?.sales?.reduce(
    (sum, sale) =>
      sum +
      (sale?.paymentDetails?.reduce(
        (paymentSum, payment) => paymentSum + (payment?.paidAmount || 0),
        0,
      ) || 0),
    0,
  );

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getMyCollection({
        clinicId,
        receivedById: clinicInfo[0]?.userId?._id,
        currentDate: currentDate,
        token,
      }),
    );
  }, [clinicInfo, clinicId, dispatch, token]);

  const generatePDF = () => {
    const card = cardRef.current;

    html2canvas(card, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
      pdf.save("collection_summary.pdf");
    });
  };
  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="m-0">My Collection</h4>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/invoice")}
        >
          Back to List
        </button>
      </div>
      <div className="container mt-3">
        <div
          className="card p-4 shadow-lg d-flex flex-column"
          ref={cardRef}
          style={{
            color: "#000",
            height: "1623px",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div className="text-center mb-3">
            <h3
              className={styles.InvoiceHeading}
              style={{ textDecoration: "underline", color: "#000" }}
            >
              COLLECTION SUMMARY
            </h3>
          </div>

          <div
            className="d-flex align-items-start mt-4"
            style={{ color: "#000" }}
          >
            <div>
              <span>Received By</span>
              <br />
              <span>Received Time</span>
            </div>
            <div className="mx-4">
              <span>
                <b>
                  {myCollection?.sales?.[0]?.paymentDetails[0]?.receivedBy
                    ?.name || "N/A"}
                </b>
              </span>
              <br />
              <b>
                {myCollection?.sales?.[0]?.paymentDetails?.[0]?.paymentDate
                  ? new Date(
                      myCollection.sales[0].paymentDetails[0].paymentDate,
                    ).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })
                  : "N/A"}
              </b>
            </div>
            <div className="ms-auto">
              <b>
                {myCollection?.sales?.[0]?.paymentDetails?.[0]?.paymentDate
                  ? new Date(
                      myCollection.sales[0].paymentDetails[0].paymentDate,
                    ).toLocaleDateString("en-CA")
                  : "N/A"}
              </b>
            </div>
          </div>
          <table
            className="table mt-4 text-center"
            style={{ borderCollapse: "collapse", color: "#000" }}
          >
            <thead
              style={{
                backgroundColor: "#07bc0c",
                color: "#fff",
                height: "40px",
              }}
            >
              <tr>
                <th style={{ padding: "5px" }}>Customer Name</th>

                <th style={{ padding: "5px" }}>Receipt Id</th>
                <th style={{ padding: "5px" }}>Service</th>
                <th style={{ padding: "5px" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {myCollection?.sales?.length > 0 ? (
                myCollection.sales.map((sale, saleIndex) => {
                  const appointment = sale?.appointmentId?.[0] || {};
                  const patient = appointment?.patientId?.userId || {};
                  const service = appointment?.service || {};

                  return sale?.paymentDetails?.length > 0 ? (
                    sale.paymentDetails.map((payment, paymentIndex) => (
                      <tr key={`${saleIndex}-${paymentIndex}`}>
                        <td>{patient?.name || "N/A"}</td>

                        <td>{sale?.receiptId || "N/A"}</td>
                        <td>{service?.serviceName || "N/A"}</td>
                        <td>{payment?.paidAmount || "N/A"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr key={saleIndex}>
                      <td>{patient?.name || "N/A"}</td>
                      <td>Dr. Smith</td>
                      <td>{sale?.receiptId || "N/A"}</td>
                      <td>{service?.serviceName || "N/A"}</td>
                      <td>N/A</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5">No data available</td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="d-flex justify-content-end w-100">
            <span className="fw-bold me-2">Total:</span>
            <span>{totalAmount}</span>
          </div>

          {/* Bottom-Fixed Section */}
          <div
            style={{
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "100%",
              backgroundColor: "#fff",
              padding: "10px",
            }}
          >
            <div
              className="d-flex justify-content-between mt-4 ms-5 me-5"
              style={{ padding: "10px", fontWeight: "bold" }}
            >
              <span>Billed By: SimpleeKare</span>
              <span>Signature</span>
            </div>
            <div className="row pb-4 ps-5 pe-5">
              <div style={{ backgroundColor: "#40be47", padding: "1px" }}></div>
              <div className="col-sm-12 p-0 mt-4">
                <div className="brand-logo d-flex align-items-center justify-content-between">
                  <img
                    className="logo-abbr me-2"
                    src={qrcode}
                    alt=""
                    style={{ width: "80px" }}
                  />
                  <b style={{ fontSize: "0.85rem" }}>
                    * No Extra Amount to be paid apart from Billing Amount.
                  </b>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          className="btn btn-primary mt-3 text-white"
          onClick={generatePDF}
        >
          Download PDF
        </button>
      </div>
    </>
  );
};

export default MyCollection;
